import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { TemplateItem } from './templateItem';
import Styles from '../../styles/templates/template.module.css';
import { Trans } from 'react-i18next';

export default function TemplateSelector({ values, onSelect, selectedTemplate }) {
    return (
        <Grid className={Styles['template-cards']}>
            {values && values.length > 0 ? (
                <Grid.Row>
                    {values.map(template => (
                        <Grid.Column key={template.id} mobile={16} tablet={5} computer={3}>
                            <TemplateItem
                                template={template}
                                onSelect={() => onSelect(template.id === selectedTemplate ? null : template.id)}
                                selectedTemplate={selectedTemplate}
                            />
                        </Grid.Column>
                    ))}
                </Grid.Row>
            ) : (
                <Grid.Row centered>
                    <div className={Styles['no-template']}>
                        <Trans i18nKey="ticket.mailing.no-data" />
                    </div>
                </Grid.Row>
            )}
        </Grid>
    );
}

TemplateSelector.propTypes = {
    values: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    selectedTemplate: PropTypes.number
};
